/**
 * Basic Mining actions (Levels 1-40).
 *
 * These are the entry-level mining actions that players start with.
 */

import type { ActionDefinition } from '@idle-depths/shared';

/**
 * Mine Copper Ore action.
 *
 * The most basic mining action, available from level 1.
 */
export const MINE_COPPER: ActionDefinition = {
  id: 'mine_copper',
  skillId: 'mining',
  name: 'Mine Copper Ore',
  description: 'Extract copper ore from copper rocks. A soft, common metal.',
  levelRequired: 1,
  baseTimeMs: 3000, // 3 seconds
  baseXP: 10,
  requirements: [],
  outputs: [], // Deferred to loot system
};

/**
 * Mine Tin Ore action.
 *
 * Another basic ore, often found alongside copper.
 */
export const MINE_TIN: ActionDefinition = {
  id: 'mine_tin',
  skillId: 'mining',
  name: 'Mine Tin Ore',
  description: 'Extract tin ore from tin rocks. Essential for bronze alloy.',
  levelRequired: 1,
  baseTimeMs: 3000, // 3 seconds
  baseXP: 10,
  requirements: [],
  outputs: [],
};

/**
 * Mine Iron Ore action.
 *
 * The first tier-2 ore, requires level 15.
 */
export const MINE_IRON: ActionDefinition = {
  id: 'mine_iron',
  skillId: 'mining',
  name: 'Mine Iron Ore',
  description: 'Extract iron ore from iron rocks. A strong, versatile metal.',
  levelRequired: 15,
  baseTimeMs: 6000, // 6 seconds
  baseXP: 30,
  requirements: [],
  outputs: [],
};

/**
 * Mine Coal action.
 *
 * Essential for smelting higher-tier ores.
 */
export const MINE_COAL: ActionDefinition = {
  id: 'mine_coal',
  skillId: 'mining',
  name: 'Mine Coal',
  description: 'Extract coal from coal rocks. Used to fuel forges and smelt metals.',
  levelRequired: 25,
  baseTimeMs: 8000, // 8 seconds
  baseXP: 45,
  requirements: [],
  outputs: [],
};

/**
 * All basic mining actions (levels 1-40).
 */
export const MINING_BASIC_ACTIONS: ActionDefinition[] = [
  MINE_COPPER,
  MINE_TIN,
  MINE_IRON,
  MINE_COAL,
];
